const idfMethods = {
  GetUserDetails: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/GetUserDetails',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetCitiesServiceCenters: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/GetCitiesServiceCenters',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  InsertOrderDetails: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/InsertOrderDetails',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  NotifyUserDevice: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/NotifyUserDevice',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['Email', 'Cat_no', 'Color', 'Phone_Name'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  InsertOrderDetailsPhoneUpgrade: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/InsertOrderDetailsPhoneUpgrade',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetProductsList: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/GetProductsList',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetProductDetails: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/GetProductDetails',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['modelId', 'isLeasing'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetPriceByPaymentCount: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/GetPriceByPaymentCount',
    httpMethod: 'get',
    isJsonRequest: false,
    timeout: 50000,
    getArgumentName: ['count', 'itemId', 'isLeasing'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  GetCustomerExposure: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'Ban/GetCustomerExposure',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },

  DataPackageExpansionInit: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/DataPackageExpansionInit',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriberNo'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  DataPackageExpansionExecute: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/DataPackageExpansion',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['subscriberNo', 'socBlockId', 'socToRemove'],
    headers: {
      'Content-Type': 'application/json',
    },
    error: [{code: '009', description: 'ארעה שגיאה'}],
  },
  NewPlanSignupInit: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/NewPlanSignupInit',
    httpMethod: 'get',
    isJsonRequest: false,
    getArgumentName: ['subscriberNo'],
    headers: {
      'Content-Type': 'application/json'
    },
    error: [{code: '009', description: 'ארעה שגיאה'}]
  },
  NewPlanSignup: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/NewPlanSignup',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: ['subscriberNo', 'socBlockId', 'signupForm'],
    headers: {
      'Content-Type': 'application/json'
    },
    error: [{code: '009', description: 'ארעה שגיאה'}]
  },
  GetUserSignatureForm: {
    online: true,
    requiredLogin: true,
    apiSuffixName: 'IDFService/GetUserSignatureForm',
    httpMethod: 'post',
    isJsonRequest: false,
    getArgumentName: [],
    headers: {
      'Content-Type': 'application/json'
    },
    error: [{code: '009', description: 'ארעה שגיאה'}]
  }
};
export default idfMethods;
